var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
define(["require", "exports", "backbone"], function (require, exports, Backbone) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MindbreezeView = void 0;
    exports.makeEl = makeEl;
    exports.cel = cel;
    exports.htmlToEl = htmlToEl;
    Backbone = __importStar(Backbone);
    function makeEl(tag, atts) {
        const el = document.createElement(tag);
        if (atts != null) {
            for (const [k, v] of Object.entries(atts)) {
                el.setAttribute(k, v);
            }
        }
        return el;
    }
    function cel(tagName, options) {
        const el = document.createElement(tagName);
        if (options.className) {
            el.className = options.className;
        }
        if (options.id) {
            el.id = options.id;
        }
        if (options.style) {
            el.setAttribute("style", options.style);
        }
        return el;
    }
    function htmlToEl(html) {
        const tpl = document.createElement("template");
        tpl.innerHTML = html.trim();
        const childNodeSize = tpl.content.childNodes.length;
        if (childNodeSize != 1) {
            throw new Error(`Failed to convert html to element, expected 1 chilNode, obtained ${childNodeSize}`);
        }
        return tpl.content.firstChild;
    }
    class MindbreezeView extends Backbone.View {
        constructor(options) {
            // super constructs the view
            // calls 
            // - _configure (extracts options into members)
            // - _ensureElement (ensures that this.el is available)
            // - initialize (empty by default)
            super(options);
        }
        initialize(options) {
            this.application = options.application;
            this.options = options;
            this.els = {};
            this.render();
        }
        ensureEl(key, tagName, options) {
            var created = false;
            if (!this.els[key]) {
                this.els[key] = cel(tagName, options);
                created = true;
            }
            return [this.els[key], created];
        }
        getEl(key) {
            return this.els[key];
        }
    }
    exports.MindbreezeView = MindbreezeView;
});
